export const DivisionDtoToDivision = (DivisionDto) => DivisionDto
    ? DivisionDto?.map(dto => ({
        divisionId: dto.DivisaoID || '',
        divisionName: dto.NomeDivisao || '',
        fleetQtt: dto.QtdFrotas || '',
        notAssigned: dto.NaoAtribuido || '',
    }))
    : [];
export const GroupDtoToGroup = (GroupDto) => GroupDto
    ? GroupDto?.map(dto => ({
        groupId: dto.GrupoID || '',
        groupName: dto.Nome || '',
        groupDivision: DivisionDtoToDivision(dto.Divisao),
    }))
    : [];
export const PermissionDtoToPermission = (permissionDto) => {
    const permissions = [];
    permissionDto?.map(item => {
        switch (item.Rota) {
            case 'report-geo-distribution':
                return permissions.push('fleetDist');
            case 'report-maintenance':
                return permissions.push('entraceExit');
            case 'report-models':
                return permissions.push('models');
            case 'report-service':
                return permissions.push('services');
            case 'scheduling':
                return permissions.push('createSchedule');
            case 'scheduling-report':
                return permissions.push('scheduleList');
            case 'agendamentolote':
                return permissions.push('multiple');
            case 'faq':
                return permissions.push('faq');
            case 'faturamento':
                return permissions.push('finan');
            case 'logsacesso':
                return permissions.push('logs');
            default:
                return;
        }
    });
    return permissions;
};
export const CurrentGroupDtoToCurrentGroup = (CurrentGroupDto) => ({
    currentGroupId: CurrentGroupDto.GrupoID || '',
    currentGroupName: CurrentGroupDto.Nome || '',
    currentGroupDivision: DivisionDtoToDivision(CurrentGroupDto.Divisao),
});
export const UserDtoToUser = (userDto) => ({
    success: userDto.usuarioVetor.success || true,
    name: userDto.usuarioVetor.Nome || '',
    email: userDto.usuarioVetor.Email || '',
    phone: userDto.usuarioVetor.Celular || '',
    managerId: userDto.usuarioVetor.GestorID || '',
    cpf: userDto.usuarioVetor.CPF || '',
    currentGroupId: userDto.usuarioVetor.GrupoIDAtual || '',
    currentDivisionId: userDto.usuarioVetor.DivisaoIDAtual || '',
    totalErrors: userDto.usuarioVetor.total_errors || 0,
    msnErrors: userDto.usuarioVetor.msn_errors
        ? userDto.usuarioVetor.msn_errors
        : userDto.usuarioVetor.message
            ? [userDto.usuarioVetor.message]
            : [],
    groups: GroupDtoToGroup(userDto.usuarioVetor.Grupos),
    geid: userDto.usuarioVetor.GEID || '',
    abbreviation: userDto.usuarioVetor.Abreviatura || '',
    firstAccess: userDto.usuarioVetor.FirstAccess || '',
    provisionalPassword: userDto.usuarioVetor.ProvisionalPassword || '',
    permissions: PermissionDtoToPermission(userDto.usuarioVetor.Permissoes),
    mainScreen: userDto.usuarioVetor.TelaPrincipal || '',
    currentGroup: CurrentGroupDtoToCurrentGroup(userDto.usuarioVetor.GrupoAtual),
    dashboardConfig: userDto.dashboardConfig
        ? userDto.dashboardConfig.sections
        : null,
    token: userDto.accessToken || '',
    refreshToken: userDto.refreshToken,
    logo: userDto.logo,
    title: userDto.titulo,
    color: userDto.cor,
    step: userDto.etapaOnboarding,
    costCenters: null,
});
